<template>
  <v-form
    dense
  >
    <v-checkbox
      v-model="customer.generate_password"
      :error-count="customer.displayErrors('generate_password').length"
      :error-messages="customer.displayErrors('generate_password')"
      :label="$t('Generate password')"
      @change="customer.require_password_change = customer.generate_password"/>
    <v-checkbox
      v-model="customer.require_password_change"
      :error-count="customer.displayErrors('require_password_change').length"
      :error-messages="customer.displayErrors('require_password_change')"
      :disabled="customer.generate_password"
      :label="$t('Require password change on first login')"
    />

    <v-text-field
      v-if="!customer.generate_password"
      v-model="customer.password"
      :error-count="customer.displayErrors('password').length"
      :error-messages="customer.displayErrors('password')"
      :label="$t('New password')"
      outline
      type="password"
    />

    <v-text-field
      v-if="!customer.generate_password"
      v-model="customer.password_confirmation"
      :error-count="customer.displayErrors('password_confirmation').length"
      :error-messages="customer.displayErrors('password_confirmation')"
      :label="$t('New password confirmation')"
      outline
      type="password"
    />
  </v-form>
</template>

<script>
export default {
  name: 'CustomerPasswordForm',

  props: {
    customer: {
      type: Object,
      required: true
    }
  }
}
</script>
